module.exports = __webpack_public_path__ + "img/map_small.99fd76d9.svg";